import { AfterViewInit, Component, EventEmitter, Inject, OnInit, Output, ViewChild } from '@angular/core';
import { UnifiedBankAccount } from '../../../../../models/entities/unified-bank-account';
import { BankReconciliationService, GetLastReconciliationResponse } from '../../../../../services/accounting/bank-reconciliation.service';
import { BankReconciliation } from '../../../../../models/entities/bank-reconciliation';
import { ActivatedRoute, Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Subject } from 'rxjs';
import { distinctUntilChanged, switchMap, takeUntil } from 'rxjs/operators';
import { MatLegacyTable as MatTable, MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { MatLegacyPaginator as MatPaginator } from '@angular/material/legacy-paginator';
import { JwtLegFiClaims } from '../../../../../services/auth/jwt-legfi-claims.model';
import { LegFiJwtService } from '../../../../../services/auth/legfi-jwt.service';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { GrowlerService } from '../../../../../services/growler.service';
import { GenericDialogResult } from '../../../shared/generic-mat-dialog/generic-dialog-result';
import { ConfirmActionDialogComponent, ConfirmActionDialogInput } from '../../../shared/confirm-action-dialog/confirm-action-dialog.component';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import moment from 'moment-timezone';
import { LegfiCurrencyPipe } from '../../../../../pipes/format/legfi-currency.pipe';
import { greaterEndDateInRangeValidator } from '../../../../../directives/validators/greater-end-date-in-range.validator';
import { MatSort } from '@angular/material/sort';
import { FilteringService } from '../../../../../services/filtering.service';
import { PaymentGroup } from 'app/models/entities/payment-group';
import { PaymentGroupsService } from 'app/services/payment/payment-groups.service';

export interface EditPaymentDialogInput
{
    paymentGroup: PaymentGroup;
}

@UntilDestroy()
@Component({
    selector: 'app-edit-payment-dialog', templateUrl: './edit-payment-dialog.component.html',
})
export class EditPaymentDialogComponent implements OnInit
{
    formGroup: UntypedFormGroup;
    isSubmitting = false;

    constructor(
            private _dialogRef: MatDialogRef<EditPaymentDialogComponent>,
            private _fb: UntypedFormBuilder,
            private _paymentGroups: PaymentGroupsService,
            private _growler: GrowlerService,
            @Inject(MAT_DIALOG_DATA) public data: EditPaymentDialogInput,
    ) {
    }

    ngOnInit() {
        this.formGroup = this._fb.group({
            createdAt: [
                this.data.paymentGroup.createdAt,
                Validators.required,
            ],
            memo: [
                this.data.paymentGroup.notes?.length ? this.data.paymentGroup.notes[0].note : '',
            ],
        });
    }

    submit() {
        if (!this.formGroup.valid) {
            return;
        }

        this.isSubmitting = true;
        this._paymentGroups.editPaymentGroup(
                this.data.paymentGroup.organizationId,
                this.data.paymentGroup.id,
                this.formGroup.getRawValue(),
        ).subscribe({
            next: () => {
                this._growler.success('Success', 'Payment successfully updated.');
                this._dialogRef.close(<GenericDialogResult>{success: true});
                this.isSubmitting = false;
            },
            error: () => {
                this._growler.oops('Could not update your payment. Please try again.');
                this.isSubmitting = false;
            },
        });
    }
}
